// Constants definition for both widgets Summary and Details
const WP_Constants = {
  OPERATIONS_OPENED: 'OPERATIONS_OPENED',
  OPERATIONS_CLOSED: 'OPERATIONS_CLOSED',
  OPERATIONS_DEFERRED: 'OPERATIONS_DEFERRED',
  OPERATIONS_WITHTS: 'OPERATIONS_WITHTS',
  OPERATIONS_TS: 'OPERATIONS_TS',
  OPERATIONS: 'OPERATIONS',

  OPERATIONS_NOOP_OPENED: 'OPERATIONS_NOOP_OPENED',
  OPERATIONS_NOOP_CLOSED: 'OPERATIONS_NOOP_CLOSED',
  OPERATIONS_NOOP_DEFERRED: 'OPERATIONS_NOOP_DEFERRED',
  OPERATIONS_NOOP_WITHTS: 'OPERATIONS_NOOP_WITHTS',
  OPERATIONS_NOOP_TS: 'OPERATIONS_NOOP_TS',
  OPERATIONS_NOOP: 'OPERATIONS_NOOP',

  OPERATIONS_OOP_OPENED: 'OPERATIONS_OOP_OPENED',
  OPERATIONS_OOP_CLOSED: 'OPERATIONS_OOP_CLOSED',
  OPERATIONS_OOP_DEFERRED: 'OPERATIONS_OOP_DEFERRED',
  OPERATIONS_OOP_WITHTS: 'OPERATIONS_OOP_WITHTS',
  OPERATIONS_OOP_TS: 'OPERATIONS_OOP_TS',
  OPERATIONS_OOP: 'OPERATIONS_OOP',

  WORKORDERS_OPENED: 'WORKORDERS_OPENED',
  WORKORDERS_CLOSED: 'WORKORDERS_CLOSED',
  WORKORDERS_DEFERRED: 'WORKORDERS_DEFERRED',
  WORKORDERS_WITHTS: 'WORKORDERS_WITHTS',
  WORKORDERS_TS: 'WORKORDERS_TS',
  WORKORDERS: 'WORKORDERS',

  WORKORDERS_TL_OPENED: 'WORKORDERS_TL_OPENED',
  WORKORDERS_TL_CLOSED: 'WORKORDERS_TL_CLOSED',
  WORKORDERS_TL_DEFERRED: 'WORKORDERS_TL_DEFERRED',
  WORKORDERS_TL_WITHTS: 'WORKORDERS_TL_WITHTS',
  WORKORDERS_TL_TS: 'WORKORDERS_TL_TS',
  WORKORDERS_TL: 'WORKORDERS_TL',

  WORKORDERS_MC_OPENED: 'WORKORDERS_MC_OPENED',
  WORKORDERS_MC_CLOSED: 'WORKORDERS_MC_CLOSED',
  WORKORDERS_MC_DEFERRED: 'WORKORDERS_MC_DEFERRED',
  WORKORDERS_MC_WITHTS: 'WORKORDERS_MC_WITHTS',
  WORKORDERS_MC_TS: 'WORKORDERS_MC_TS',
  WORKORDERS_MC: 'WORKORDERS_MC',

  ADDWRK_OPENED: 'ADDWRK_OPENED',
  ADDWRK_CLOSED: 'ADDWRK_CLOSED',
  ADDWRK_DEFERRED: 'ADDWRK_DEFERRED',
  ADDWRK_WITHTS: 'ADDWRK_WITHTS',
  ADDWRK_FROMTS: 'ADDWRK_FROMTS',

  WORKORDERS_DOC_OPENED: 'WORKORDERS_DOC_OPENED',
  WORKORDERS_DOC_CLOSED: 'WORKORDERS_DOC_CLOSED',
  WORKORDERS_DOC_DEFERRED: 'WORKORDERS_DOC_DEFERRED',
  WORKORDERS_DOC_WITHTS: 'WORKORDERS_DOC_WITHTS',
  WORKORDERS_DOC_TS: 'WORKORDERS_DOC_TS',
  WORKORDERS_DOC: 'WORKORDERS_DOC',

  WORKORDERS_KX_OPENED: 'WORKORDERS_KX_OPENED',
  WORKORDERS_KX_CLOSED: 'WORKORDERS_KX_CLOSED',
  WORKORDERS_KX_DEFERRED: 'WORKORDERS_KX_DEFERRED',
  WORKORDERS_KX_WITHTS: 'WORKORDERS_KX_WITHTS',
  WORKORDERS_KX_TS: 'WORKORDERS_KX_TS',
  WORKORDERS_KX: 'WORKORDERS_KX',

  WORKORDERS_MIS_OPENED: 'WORKORDERS_MIS_OPENED',
  WORKORDERS_MIS_CLOSED: 'WORKORDERS_MIS_CLOSED',
  WORKORDERS_MIS_DEFERRED: 'WORKORDERS_MIS_DEFERRED',
  WORKORDERS_MIS_WITHTS: 'WORKORDERS_MIS_WITHTS',
  WORKORDERS_MIS_TS: 'WORKORDERS_MIS_TS',
  WORKORDERS_MIS: 'WORKORDERS_MIS',

  TOTAL_OPENED: 'TOTAL_OPENED',
  TOTAL_CLOSED: 'TOTAL_CLOSED',
  TOTAL_DEFERRED: 'TOTAL_DEFERRED',
  TOTAL_WITHTS: 'TOTAL_WITHTS',
  TOTAL_TS: 'TOTAL_TS',
  TOTAL: 'TOTAL',
}

export default WP_Constants
